<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">For:</p><p class="ded1">Bas, the priestess of Shanville</p><p class="ded1"> OBE’s (Order of the Bloody Entrails) to: Emma “Morrigan” Bradshaw</p><p class="ded">Geraldine “sarsaparilla” Stroud Mary “Macha” Byrne</p><p class="ded1">Hewn into shape by:</p><p class="ded"> Stella “seanachaidh” Paskins</p><p class="ded1">Fellow questers: the Christopher McLittle clan</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bec_dedi-1.vue?118f4276